import type {
  OneSchemaJWTRequest,
  OneSchemaJWTResponse,
} from '@/types/api/one-schema'

import { baseApiSlice } from './base-api-slice'

const oneSchemaSlice = baseApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    generateJWT: builder.mutation<OneSchemaJWTResponse, OneSchemaJWTRequest>({
      query: ({ metadata }) => ({
        url: `bff/one-schema/jwt/`,
        method: 'POST',
        body: { metadata },
      }),
    }),
  }),
})

export const {
  endpoints: { generateJWT },
} = oneSchemaSlice
